import { NoMediaLinkIcon, UploadIcon2 } from '@/components/common/icon';
import { Button } from 'aha-components';
import { useTranslation } from 'react-i18next';

export type AudienceDataActionButtonsProps = {
  stacked?: boolean;
  responsive?: boolean;
  showLink?: boolean;
  linkLoading?: boolean;
  disabled?: boolean;
  onUpload: () => void;
  onLink?: () => void;
};

export default function AudienceDataActionButtons({
  stacked = false,
  responsive = false,
  showLink = true,
  linkLoading = false,
  disabled = false,
  onUpload,
  onLink
}: AudienceDataActionButtonsProps) {
  const { t } = useTranslation();
  const buttonWidthClass = responsive
    ? '!w-full !min-w-0 md:!w-auto md:!flex-1'
    : stacked
      ? '!w-[260px] !max-w-full'
      : '!w-auto !flex-1';

  return (
    <div
      className={`flex w-full items-center justify-center ${
        responsive
          ? 'flex-col gap-2 md:flex-row md:gap-3'
          : stacked
            ? 'flex-col gap-2'
            : 'flex-row gap-3 px-4 pb-4'
      }`}
    >
      <Button
        className={`${buttonWidthClass} !h-10 !rounded-lg`}
        disabled={disabled}
        onClick={onUpload}
      >
        <span className="flex items-center justify-center gap-2">
          <UploadIcon2 className="h-5 w-5 text-[#A3A3A3]" />
          <span>
            {t(
              'modal.modal_take_order.audience_demographics.upload_screenshots',
              { defaultValue: 'Upload screenshots' }
            )}
          </span>
        </span>
      </Button>

      {showLink ? (
        <>
          <span className="text-xs leading-[18px] text-[#737373]">
            {t('multi_platform.quote.or', { defaultValue: 'Or' })}
          </span>
          <Button
            className={`${buttonWidthClass} !h-10 !rounded-lg`}
            disabled={disabled}
            loading={linkLoading}
            onClick={onLink}
          >
            <span className="flex items-center justify-center gap-2">
              <NoMediaLinkIcon className="h-5 w-5 text-[#A3A3A3]" />
              <span>
                {t(
                  'modal.modal_take_order.audience_demographics.link_channel',
                  { defaultValue: 'Link channel' }
                )}
              </span>
            </span>
          </Button>
        </>
      ) : null}
    </div>
  );
}
